import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-anchor-center-down-icon',
  templateUrl: './design-anchor-center-down.component.html'
})
export class DesignAnchorCenterDownComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
